import { useEffect, useRef } from "react";

export function useCurrentValueRef<T>(value: T) {
  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref
}
